export const neasc = {
  title: "Acreditação Internacional NEASC",
  subtitle: "Gándara International School está acreditado pela New England Association of Schools and Colleges (NEASC), uma das organizações de acreditação educacional mais prestigiosas do mundo.",
  badge: "Escola Acreditada NEASC",
  learnMore: "Saiba mais sobre NEASC",
  learnMoreUrl: "https://www.neasc.org",
  benefits: {
    quality: {
      title: "Garantia de Qualidade",
      description: "Verificação externa e independente de que cumprimos os mais altos padrões educacionais internacionais."
    },
    recognition: {
      title: "Reconhecimento Global",
      description: "Nossos diplomas e certificados são reconhecidos por instituições educacionais em todo o mundo."
    },
    improvement: {
      title: "Melhoria Contínua",
      description: "Compromisso permanente com a avaliação e melhoria de nossos programas, instalações e metodologias."
    },
    transferability: {
      title: "Transferibilidade",
      description: "Facilita a transição de estudantes para outras escolas acreditadas na Espanha e no exterior."
    }
  }
};
